"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmailSentInfo = require("./EmailSentInfo");
Object.keys(_EmailSentInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmailSentInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmailSentInfo[key];
    }
  });
});